var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAnnouncement = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sb-icons/24x24/announcement") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sb-icons/24x24/announcement",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.097196,9.15656911 L18.942035,9.15656911 L18.942035,4 L18.0001959,4 L18.0001959,5.36566671 L4.57898861,8.92110933 L1,8.92110933 L1,15.7965348 L4.57898861,15.7965348 L5.12054609,15.9378107 L5.12054609,19.846443 L13.1261785,19.846443 L13.1261785,18.0569487 L18.0001959,19.3519774 L18.0001959,20.7176442 L18.942035,20.7176442 L18.942035,15.561075 L22.097196,15.561075 L22.097196,9.15656911 Z M1.96538508,9.86294844 L4.17870699,9.86294844 L4.17870699,14.8546957 L1.94183911,14.8546957 L1.96538508,9.86294844 Z M12.1607934,18.9046039 L6.03883922,18.9046039 L6.03883922,16.1968164 L12.1607934,17.8214889 L12.1607934,18.9046039 Z M5.09700012,14.9488796 L5.09700012,9.74521855 L18.0001959,6.33105179 L18.0001959,18.3865924 L5.09700012,14.9488796 Z M21.1318109,14.59569 L18.942035,14.59569 L18.942035,10.0984082 L21.1553569,10.0984082 L21.1318109,14.59569 Z",
    id: "Shape",
    stroke: "#FFFFFF",
    strokeWidth: 0.8,
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAnnouncement);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/announcement.e07eaed1d2e18cc5176ce0c87ecc1086.svg";